import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { playSound } from "../../game/scenes/classes/PlaySound";

export default function ForfeitPenaltyModal({ show, onHide }) {
    const handleClose = () => {
        playSound("clickSound");
        // Clear the session storage so the warning can be shown again if needed
        sessionStorage.removeItem('forfeitPenaltyWarningShown');
        onHide();
    };

    // Play warning sound when modal opens
    useEffect(() => {
        if (show) {
            // Play a warning sound if available
            const audio = new Audio('/bonez/sounds/damage_bonez_zoombies.mp3');
            audio.volume = 0.3;
            audio.play().catch(e => console.log('Audio play failed:', e));
        }
    }, [show]);

    // Add touch-friendly enhancements for mobile
    useEffect(() => {
        if (show) {
            // Prevent body scroll when modal is open on mobile
            document.body.style.overflow = 'hidden';
            
            // Add touch event listeners for better mobile experience
            const modalElement = document.querySelector('.forfeit-penalty-modal-mobile');
            if (modalElement) {
                modalElement.style.touchAction = 'manipulation';
            }
            
            return () => {
                document.body.style.overflow = 'auto';
            };
        }
    }, [show]);

    // Add a pulsing effect for the warning icon
    const pulseStyle = {
        animation: 'pulse 2s infinite',
        display: 'inline-block'
    };

    // Add CSS animation styles and mobile responsive styles
    const animationStyles = `
        @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.2); }
            100% { transform: scale(1); }
        }
        
        .forfeit-penalty-modal-mobile .modal-dialog {
            max-width: 95vw !important;
            margin: 10px auto;
            height: 90vh;
            display: flex;
            flex-direction: column;
        }
        
        .forfeit-penalty-modal-mobile .modal-content {
            height: 100%;
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }
        
        .forfeit-penalty-modal-mobile .modal-body {
            flex: 1;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
        }
        
        .forfeit-penalty-modal-mobile .modal-footer {
            flex-shrink: 0;
            margin-top: auto;
        }
        
        .forfeit-penalty-modal-mobile .modal-dialog {
            touch-action: manipulation;
            -webkit-user-select: none;
            user-select: none;
        }
        
        .forfeit-penalty-modal-mobile .modal-content > * {
            flex-shrink: 0;
        }
        
        .forfeit-penalty-modal-mobile .modal-content .modal-body {
            flex: 1;
            min-height: 0;
        }
        
        @media (max-width: 768px) and (orientation: landscape) {
            .forfeit-penalty-modal-mobile .modal-dialog {
                max-width: 98vw !important;
                margin: 5px auto;
                height: 95vh;
                max-height: 95vh;
            }
            
            .forfeit-penalty-modal-mobile .modal-content {
                height: 100%;
                max-height: 95vh;
                overflow: hidden;
            }
            
            .forfeit-penalty-modal-mobile .modal-header {
                padding: 0.5rem;
                min-height: auto;
                flex-shrink: 0;
            }
            
            .forfeit-penalty-modal-mobile .modal-body {
                padding: 0.75rem;
                flex: 1;
                overflow-y: auto;
                min-height: 0;
            }
            
            .forfeit-penalty-modal-mobile .modal-footer {
                padding: 0.5rem;
                min-height: auto;
                flex-shrink: 0;
                margin-top: auto;
            }
            
            .forfeit-penalty-modal-mobile .modal-title {
                font-size: 1.8rem !important;
                line-height: 1.1 !important;
            }
            
            .forfeit-penalty-modal-mobile h2 {
                font-size: 1.5rem !important;
                margin-bottom: 0.75rem !important;
            }
            
            .forfeit-penalty-modal-mobile p {
                font-size: 1.2rem !important;
                margin-bottom: 0.75rem !important;
                line-height: 1.3 !important;
            }
            
            .forfeit-penalty-modal-mobile h3 {
                font-size: 1.3rem !important;
                margin-bottom: 0.6rem !important;
            }
            
            .forfeit-penalty-modal-mobile li {
                font-size: 1.1rem !important;
                margin-bottom: 0.3rem !important;
                line-height: 1.2 !important;
            }
            
            .forfeit-penalty-modal-mobile .btn {
                font-size: 1.2rem !important;
                padding: 0.5rem 1.5rem !important;
                width: 100% !important;
                max-width: 300px !important;
                min-height: 60px !important;
            }
            
            .forfeit-penalty-modal-mobile div[style*="background-color"] {
                padding: 0.75rem !important;
                margin-bottom: 0.75rem !important;
            }
        }
        
        @media (max-width: 480px) and (orientation: landscape) {
            .forfeit-penalty-modal-mobile .modal-dialog {
                max-width: 99vw !important;
                margin: 3px auto;
                height: 98vh;
                max-height: 98vh;
            }
            
            .forfeit-penalty-modal-mobile .modal-content {
                height: 100%;
                max-height: 98vh;
                overflow: hidden;
            }
            
            .forfeit-penalty-modal-mobile .modal-header {
                padding: 0.4rem;
                flex-shrink: 0;
            }
            
            .forfeit-penalty-modal-mobile .modal-body {
                padding: 0.5rem;
                flex: 1;
                overflow-y: auto;
                min-height: 0;
            }
            
            .forfeit-penalty-modal-mobile .modal-footer {
                padding: 0.4rem;
                flex-shrink: 0;
                margin-top: auto;
            }
            
            .forfeit-penalty-modal-mobile .modal-title {
                font-size: 1.5rem !important;
                line-height: 1.1 !important;
            }
            
            .forfeit-penalty-modal-mobile h2 {
                font-size: 1.3rem !important;
                margin-bottom: 0.6rem !important;
            }
            
            .forfeit-penalty-modal-mobile p {
                font-size: 1.1rem !important;
                margin-bottom: 0.6rem !important;
                line-height: 1.2 !important;
            }
            
            .forfeit-penalty-modal-mobile h3 {
                font-size: 1.2rem !important;
                margin-bottom: 0.5rem !important;
            }
            
            .forfeit-penalty-modal-mobile li {
                font-size: 1rem !important;
                margin-bottom: 0.25rem !important;
                line-height: 1.1 !important;
            }
            
            .forfeit-penalty-modal-mobile .btn {
                font-size: 1.1rem !important;
                padding: 0.4rem 1.2rem !important;
                width: 100% !important;
                max-width: 300px !important;
                min-height: 50px !important;
            }
            
            .forfeit-penalty-modal-mobile div[style*="background-color"] {
                padding: 0.6rem !important;
                margin-bottom: 0.6rem !important;
            }
        }
        
        @media (max-height: 500px) and (orientation: landscape) {
            .forfeit-penalty-modal-mobile .modal-dialog {
                height: 98vh;
                max-height: 98vh;
                margin: 2px auto;
            }
            
            .forfeit-penalty-modal-mobile .modal-content {
                height: 100%;
                max-height: 98vh;
                overflow: hidden;
            }
            
            .forfeit-penalty-modal-mobile .modal-body {
                flex: 1;
                overflow-y: auto;
                padding: 0.5rem;
                min-height: 0;
            }
            
            .forfeit-penalty-modal-mobile .modal-header {
                padding: 0.3rem;
                flex-shrink: 0;
            }
            
            .forfeit-penalty-modal-mobile .modal-footer {
                padding: 0.3rem;
                flex-shrink: 0;
                margin-top: auto;
            }
            
            .forfeit-penalty-modal-mobile .btn {
                font-size: 1rem !important;
                padding: 0.3rem 1rem !important;
                width: 100% !important;
                max-width: 300px !important;
                min-height: 45px !important;
            }
        }
    `;

    return (
        <>
            <style>{animationStyles}</style>
            <Modal 
                show={show} 
                onHide={handleClose}
                centered
                backdrop="static"
                keyboard={false}
                size="lg"
                dialogClassName="forfeit-penalty-modal-mobile"
                style={{ maxHeight: '90vh', overflow: 'auto' }}
            >
            <Modal.Header 
                style={{ 
                    backgroundColor: '#8B0000', 
                    borderBottom: '3px solid #FF0000',
                    justifyContent: 'center',
                    padding: '0.75rem'
                }}
            >
                <Modal.Title 
                    style={{
                        fontFamily: 'Truculenta, sans-serif',
                        fontSize: '2.5rem',
                        fontWeight: 'bold',
                        color: '#FFFFFF',
                        textAlign: 'center',
                        lineHeight: '1.2'
                    }}
                >
                    ⚠️ FORFEIT PENALTY WARNING ⚠️
                </Modal.Title>
            </Modal.Header>
            
            <Modal.Body 
                style={{ 
                    backgroundColor: '#1B3A5D',
                    padding: '1.5rem',
                    textAlign: 'center',
                    flex: '1',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                <div style={{ flex: '1', display: 'flex', flexDirection: 'column' }}>
                    <h2 
                        style={{
                            fontFamily: 'Truculenta, sans-serif',
                            fontSize: '2rem',
                            fontWeight: 'bold',
                            color: '#FF6B6B',
                            marginBottom: '1rem'
                        }}
                    >
                        <span style={pulseStyle}>🚨</span> ACCOUNT FLAGGED <span style={pulseStyle}>🚨</span>
                    </h2>
                    
                    <p 
                        style={{
                            fontFamily: 'Truculenta, sans-serif',
                            fontSize: '1.5rem',
                            color: '#FFFFFF',
                            lineHeight: '1.4',
                            marginBottom: '1rem'
                        }}
                    >
                        You have recently forfeited from 3 matches! This behavior is detrimental to the gaming experience of other players.
                    </p>
                    
                    <div 
                        style={{
                            backgroundColor: '#8B0000',
                            border: '2px solid #FF0000',
                            borderRadius: '10px',
                            padding: '0.75rem',
                            marginBottom: '1rem'
                        }}
                    >
                        <p 
                            style={{
                                fontFamily: 'Truculenta, sans-serif',
                                fontSize: '1.8rem',
                                color: '#FFD700',
                                fontWeight: 'bold',
                                margin: 0
                            }}
                        >
                            ⏰ Your penalty will expire after 12 hours without a forfeit
                        </p>
                    </div>
                    
                    <div 
                        style={{
                            backgroundColor: '#2C1810',
                            border: '2px solid #FF0000',
                            borderRadius: '10px',
                            padding: '1rem',
                            marginBottom: '1rem'
                        }}
                    >
                        <h3 
                            style={{
                                fontFamily: 'Truculenta, sans-serif',
                                fontSize: '1.8rem',
                                fontWeight: 'bold',
                                color: '#FFD700',
                                marginBottom: '0.75rem'
                            }}
                        >
                            ⚡ PENALTY CONSEQUENCES ⚡
                        </h3>
                        
                        <ul 
                            style={{
                                fontFamily: 'Truculenta, sans-serif',
                                fontSize: '1.5rem',
                                color: '#FFFFFF',
                                textAlign: 'left',
                                listStyleType: 'none',
                                padding: 0
                            }}
                        >
                            <li style={{ marginBottom: '0.4rem' }}>• <span style={{ color: '#FF6B6B' }}>Extended matchmaking cooldowns</span></li>
                            <li style={{ marginBottom: '0.4rem' }}>• <span style={{ color: '#FF6B6B' }}>Reduced rewards from future matches</span></li>
                            <li style={{ marginBottom: '0.4rem' }}>• <span style={{ color: '#FF6B6B' }}>Potential temporary account suspension</span></li>
                            <li style={{ marginBottom: '0.4rem' }}>• <span style={{ color: '#FF6B6B' }}>Loss of tournament eligibility</span></li>
                        </ul>
                    </div>
                    
                    <p 
                        style={{
                            fontFamily: 'Truculenta, sans-serif',
                            fontSize: '2.0rem',
                            color: '#FFD700',
                            fontWeight: 'bold',
                            marginBottom: '0.75rem'
                        }}
                    >
                        🎯 TO AVOID FURTHER PENALTIES:
                    </p>
                    
                    <div 
                        style={{
                            backgroundColor: '#1A4D2E',
                            border: '2px solid #00FF00',
                            borderRadius: '10px',
                            padding: '0.75rem',
                            marginBottom: '1rem'
                        }}
                    >
                        <ul 
                            style={{
                                fontFamily: 'Truculenta, sans-serif',
                                fontSize: '1.5rem',
                                color: '#FFFFFF',
                                textAlign: 'left',
                                listStyleType: 'none',
                                padding: 0
                            }}
                        >
                            <li style={{ marginBottom: '0.4rem' }}>• <span style={{ color: '#90EE90' }}>Complete all matches you join</span></li>
                            <li style={{ marginBottom: '0.4rem' }}>• <span style={{ color: '#90EE90' }}>Communicate with opponents if you need to leave</span></li>
                            <li style={{ marginBottom: '0.4rem' }}>• <span style={{ color: '#90EE90' }}>Only join matches when you have time to finish</span></li>
                            <li style={{ marginBottom: '0.4rem' }}>• <span style={{ color: '#90EE90' }}>If you get disconnected, reconnect to the game as soon as possible</span></li>
                        </ul>
                    </div>
                    
                    <p 
                        style={{
                            fontFamily: 'Truculenta, sans-serif',
                            fontSize: '2.0rem',
                            color: '#FFB6C1',
                            fontStyle: 'italic',
                            marginBottom: '0.5rem'
                        }}
                    >
                        Remember: Fair play ensures everyone has an enjoyable gaming experience!
                    </p>
                </div>
            </Modal.Body>
            
            <Modal.Footer 
                style={{ 
                    backgroundColor: '#1B3A5D',
                    borderTop: '3px solid #FF0000',
                    justifyContent: 'center',
                    padding: '0.75rem',
                    marginTop: 'auto'
                }}
            >
                <Button 
                    variant="danger" 
                    size="lg"
                    onClick={handleClose}
                    style={{
                        fontFamily: 'Truculenta, sans-serif',
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        padding: '0.75rem 2rem',
                        backgroundColor: '#8B0000',
                        border: '2px solid #FF0000',
                        minHeight: '60px',
                        width: '100%',
                        maxWidth: '300px'
                    }}
                >
                    I UNDERSTAND
                </Button>
            </Modal.Footer>
            </Modal>
        </>
    );
}
